import React, { useEffect, useState } from "react";

function InstitutionPartialDataWarningBanner({
  content,
  processingText,
  onRefresh,
  refreshText,
}) {
  const [isRefreshing, setIsRefreshing] = useState(false);

  // 1. Silent Background Polling Gate (Triggers every 30 seconds)
  useEffect(() => {
    if (!processingText || typeof onRefresh !== "function") return;

    const autoPollingInterval = setInterval(async () => {
      try {
        await onRefresh();
      } catch (error) {
        console.error("Data sentinel background sync check failed:", error);
      }
    }, 30000);

    return () => clearInterval(autoPollingInterval);
  }, [processingText, onRefresh]);

  // 2. Manual Action Handler
  const handleManualRefresh = async () => {
    if (typeof onRefresh !== "function" || isRefreshing) return;
    setIsRefreshing(true);
    try {
      await onRefresh();
    } catch (error) {
      console.error("Manual pipeline refresh request failed:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  // If there are no institutions processing, don't waste layout space rendering an empty banner
  if (!processingText) return null;

  const [descriptionBeforeProcessingText, descriptionAfterProcessingText] =
    content.description.split("{processing_institutions}");

  return (
    <div className="warning-alert-container">
      <p className="warning" style={{ margin: 0, flex: 1 }}>
        <strong>{content.title}</strong> {descriptionBeforeProcessingText}
        <strong>{processingText}</strong>
        {descriptionAfterProcessingText}
      </p>

      <button
        onClick={handleManualRefresh}
        className="cta-button secondary small rounded"
        disabled={isRefreshing}
      >
        {refreshText}
      </button>
    </div>
  );
}

export default InstitutionPartialDataWarningBanner;
